export const CONTENT_PANE_CLASSNAME = 'contentEditor-contentPane';
export const EDIT_PANE_CLASSNAME = 'contentEditor-editPane';
export const PREVIEW_IFRAME_WRAPPER = 'preview-iframe-wrapper';
export const SIDEBAR_IFRAME_WRAPPER = 'sidebar-iframe-wrapper';
export const SIDEBAR_IFRAME_SPINNER_CLASSNAME = 'sidebar-iframe-spinner';
export const PATAGONIA_SKELETON_CLASSNAME = 'patagonia-skeleton';
export const DISTRACTION_FREE_CLASSNAME = 'hs-distractionfree-fullscreen';
export const EDITOR_CANVAS_CLASSNAME = 'editor-canvas';